var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00028 15.1431C9.89468 15.1431 11.7115 14.3906 13.051 13.051C14.3906 11.7115 15.1431 9.89468 15.1431 8.00028C15.1431 6.10588 14.3906 4.28906 13.051 2.94952C11.7115 1.60997 9.89468 0.857422 8.00028 0.857422C6.10588 0.857422 4.28906 1.60997 2.94952 2.94952C1.60997 4.28906 0.857422 6.10588 0.857422 8.00028C0.857422 9.89468 1.60997 11.7115 2.94952 13.051C4.28906 14.3906 6.10588 15.1431 8.00028 15.1431V15.1431Z",
    stroke: "#00B05C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14258 8.71498L7.22029 10.8578C8.19858 8.0487 9.01229 6.8167 10.8569 5.14355",
    stroke: "#00B05C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedNewIcon);
export default __webpack_public_path__ + "static/media/verified-new-icon.b27f918d6a45bcb2c7f548309372e606.svg";
export { ForwardRef as ReactComponent };